import { Navigate, Outlet } from 'react-router';
import { useConsultantAccess } from '../../hooks/consultant/use-consultant-access';
import { isGuardQuerySettling } from './guard-query-state';

/**
 * Gates the /consultant tree on the backend's own access signal
 * (`GET /consultant/access`): platform admin or Consulente membership on any
 * tenant (system role). Referral-link ownership alone does NOT grant access —
 * the backend's hasConsultantAccess counts only the membership; referral links
 * and manual assignments matter for attribution, not for the consultant area.
 * The signal is user-scoped (not tenant-scoped), so a consultant switched into
 * one of their own tenants keeps access.
 */
export function ConsultantGuard() {
  const { hasConsultantAccess, isPending, fetchStatus } = useConsultantAccess();

  if (isGuardQuerySettling({ isPending, fetchStatus })) {
    return null;
  }

  if (!hasConsultantAccess) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
}
